<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 d-flex flex-column h-100">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div
          [innerHTML]="
            isReadOnly
              ? ('tkey;reports.microsoft.custom_powershell_reports.about.read' | escapeHtml)
              : ('tkey;reports.microsoft.custom_powershell_reports.about.read_write' | escapeHtml: { tenantId })
          "
        ></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
    @if (!isLoading) {
      <ziro-datatable
        [columns]="columns"
        [rowDataSource]="tableRows"
        [dataAutomation]="'custom-powershell-queries-datatable'"
        [uniqueRowIdentifier]="'id'"
        [class]="'ziro-card'"
      ></ziro-datatable>
    }
  </div>
</div>

<ziro-bottom-nav [hidden]="isReadOnly"></ziro-bottom-nav>
